<template>
	<!--自定义包-->
	<el-row class="alltext">
		<el-button type="primary" round @click="resource_edit_click('','add')">新增资源包</el-button>
		<div class="content">
			<div class="content_right">
				<div>
					<el-table :data="resource_list.data" stripe style="width: 100%">
            <el-table-column prop="num" label="编号">
            </el-table-column>
						<el-table-column prop="name" label="包名">
						</el-table-column>
            <el-table-column prop="type" label="分类">
            </el-table-column>
						<el-table-column prop="companyee" label="录入人">
						</el-table-column>
						<el-table-column prop="content" label="备注">
						</el-table-column>
						<el-table-column>
              <template slot="header" slot-scope="scope">
                <el-input v-model="search" size="mini" @keyup.enter.native="search_click()" placeholder="输入关键字搜索" />
              </template>
							<template slot-scope="scope">
								<el-button type="text" size="small" icon="el-icon-view"
									@click="resource_watch_click(scope.row.num)"></el-button>
                 <el-dropdown >
                   <span>
                     <i class="el-icon-more-outline"></i>
                   </span>
                   <el-dropdown-menu slot="dropdown">
                       <el-dropdown-item @click.native="() =>resource_edit_click(scope.row.num,'edit')" v-show= "scope.row.enable_show">编辑</el-dropdown-item>
                       <el-dropdown-item @click.native="() =>operation_click(scope.row.num,'release')"   v-show="scope.row.release_show" >发布</el-dropdown-item>
                       <el-dropdown-item @click.native="() =>operation_click(scope.row.num,'enable_show')" v-show="scope.row.enable_show">启用</el-dropdown-item>
                       <el-dropdown-item @click.native="() =>operation_click(scope.row.num,'disable_show')" v-show="scope.row.disable_show">禁用</el-dropdown-item>
                   </el-dropdown-menu>
                 </el-dropdown>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="block">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="resource_list.current_page" :page-sizes="[10, 20, 30, 40]"
						:page-size="resource_list.per_page" layout="total, sizes, prev, pager, next, jumper"
						:total="resource_list.total">
					</el-pagination>
				</div>

			</div>
		</div>
		<!--新增和编辑弹框-->
		<el-dialog :title="nav_status.title" :visible.sync="nav_status.resource_edit_dialog">
			<el-form :model="resource_edit">
				<el-form-item label="编  号:">
					<el-input v-model="edit_dialog.uploadlist.cart_number" autocomplete="off" style="width: 30%;">
					</el-input>
				</el-form-item>
				<el-form-item label="包  名:">
					<el-input v-model="edit_dialog.uploadlist.name" autocomplete="off" style="width: 30%;"></el-input>
				</el-form-item>
				<el-form-item label="药知课程:">
					<el-button plain @click="edit_click('yz')" v-if="edit_dialog.uploadlist.xzyzvideo_list.length ==0">
						未选择，请选择</el-button>
					<el-button plain @click="edit_click('yz')" v-if="edit_dialog.uploadlist.xzyzvideo_list.length !=0">
						已选择，请编辑</el-button>
				</el-form-item>
				<el-form-item label="内部课程:">
					<el-button plain @click="edit_click('nb')" v-if="edit_dialog.uploadlist.xznbvideo_list.length ==0">
						未选择，请选择</el-button>
					<el-button plain @click="edit_click('nb')" v-if="edit_dialog.uploadlist.xznbvideo_list.length !=0">
						已选择，请编辑</el-button>
				</el-form-item>
				<el-form-item label="所属分类:">
					<el-button plain @click="edit_click('class')" v-if="edit_dialog.uploadlist.xzclass_list.length ==0">
						未选择，请选择</el-button>
					<el-button plain @click="edit_click('class')" v-if="edit_dialog.uploadlist.xzclass_list.length !=0">
						已选择，请编辑</el-button>
				</el-form-item>
				<el-form-item label="备注:">
					<el-input type="textarea" v-model="edit_dialog.uploadlist.content" autocomplete="off"
						style="width: 80%;"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="nav_status.resource_edit_dialog = false">取 消</el-button>
				<el-button type="primary" @click="resource_save()">确 定</el-button>
			</div>
		</el-dialog>

		<!--内部视频分类弹框-->
		<el-dialog title='内部视频' :visible.sync="edit_dialog.nbvideo_show">
			<div style="display: flex;  ">
				<div class="ercitankuang_left">
					<p style="margin-top: 10px;"><span style=" margin-left:10px;">分类</span>
						<span style="position:absolute;  right: 5%;">
							<el-button type="danger" icon="el-icon-delete" circle @click="nbremove()"></el-button>
							<el-button type="success" icon="el-icon-check" circle @click="nbvideo_click"></el-button>
						</span>
					</p>
					<el-input style="margin-top: 9px;" v-model="nbinput_value" placeholder="请输入内容"></el-input> <br />
					<el-tree show-checkbox :data="edit_dialog.nbvideo_list" ref="treenb" node-key="num"
						:filter-node-method="filterNodenb" :props="edit_dialog.defaultPropsnb">
					</el-tree>
				</div>
				<div class="ercitankuang_content"></div>
				<div class="ercitankuang_right">
					您选择的是：
					<!-- <div v-html="companyee_choiced.html"></div> -->
					<p v-for="(item,key) in  edit_dialog.nbshow_list">{{item.name}}</p>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="edit_dialog.nbvideo_show = false;">取 消</el-button>
				<el-button type="primary" @click="remove('nb')">确 定</el-button>
			</div>
		</el-dialog>
		<!--药知视频分类弹框-->
		<el-dialog title='药知视频' :visible.sync="edit_dialog.yzvideo_show">
			<div style="display: flex;  ">
				<div class="ercitankuang_left">
					<p style="margin-top: 10px;"><span style=" margin-left:10px;">分类</span>
						<span style="position:absolute;  right: 5%;">
							<el-button type="danger" icon="el-icon-delete" circle @click="yzremove()"></el-button>
							<el-button type="success" icon="el-icon-check" circle @click="yzvideo_click()"></el-button>
						</span>
					</p>
					<el-input style="margin-top: 9px;" v-model="yzinput_value" placeholder="请输入内容"></el-input> <br />
					<el-tree show-checkbox :data="edit_dialog.yzvideo_list" ref="treeyz" node-key="num"
						:filter-node-method="filterNodeyz" :props="edit_dialog.defaultPropsyz">
					</el-tree>
				</div>
				<div class="ercitankuang_content"></div>
				<div class="ercitankuang_right">
					您选择的是：
					<!-- <div v-html="companyee_choiced.html"></div> -->
					<p v-for="(item,key) in  edit_dialog.yzshow_list">{{item.name}}</p>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="edit_dialog.yzvideo_show = false;">取 消</el-button>
				<el-button type="primary" @click="remove('yz')">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="edit_dialog.class_show">
			<div style="display: flex;  ">
				<div class="ercitankuang_left">
					<p style="margin-top: 10px;"><span style=" margin-left:10px;">分类</span>
						<span style="position:absolute;  right: 5%;">
							<el-button type="danger" icon="el-icon-delete" circle @click="classremove()"></el-button>
							<el-button type="success" icon="el-icon-check" circle @click="classvideo_click"></el-button>
						</span>

					</p>
					<el-input style="margin-top: 9px;" v-model="classinput_value" placeholder="请输入内容"></el-input> <br />
					<el-tree show-checkbox :data="edit_dialog.class_list" ref="treeclass" node-key="num"
				  :check-strictly='true'
           @check-change="handleClick"
          :filter-node-method="filterNodeclass" :props="edit_dialog.defaultPropsclass">
					</el-tree>
				</div>
				<div class="ercitankuang_content"></div>
				<div class="ercitankuang_right">
					您选择的是：
					<p v-for="item in edit_dialog.classshow_list">{{item.name}}</p>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="edit_dialog.class_show = false;">取 消</el-button>
				<el-button type="primary" @click="remove('class')">确 定</el-button>
			</div>
		</el-dialog>

		<!--查看弹框-->
		<el-dialog title="查看" :visible.sync="nav_status.resource_watch_dialog">
      <p>资源包编号：{{resource_watch.cart_number}}</p>
			<p>资源包主题：{{resource_watch.name}}</p>
			<p>资源包分类：{{resource_watch.t_name}}</p>
			<p>资源包内容：
			<!-- <p>公共视频：
				<span v-for="(item,key) in resource_watch.video.public"
					style="padding-right: 2rem;">{{item.name}}</span>
			</p>
      <p>内部视频：
      	<span v-for="(item,key) in resource_watch.video.local"
      		style="padding-right: 2rem;">{{item.name}}</span>
      </p> -->
      <el-tabs type="border-card" style="margin-top: 1.25rem;">
        <el-tab-pane label="公共视频">
          <el-table
          :data="resource_watch.video.public"
          border
           height="250"
          style="width: 100%;">
          <el-table-column
            label="序号"
            align="center"
            type="index"
            :index="indexAdd"
            width="50"/>
           </el-table-column>
          <el-table-column
            prop="name"
            label="视频名称"
            >
          </el-table-column>
        </el-table>
        </el-tab-pane>
        <el-tab-pane label="内部视频">
          <el-table
            :data="resource_watch.video.local"
            border
             height="250"
            style="width: 100%">
            <el-table-column
              label="序号"
              align="center"
              type="index"
              :index="indexAdd"
              width="50"/>
             </el-table-column>
            <el-table-column
              prop="name"
              label="视频名称"
             >
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
			</p>
			<p>资源包备注：{{resource_watch.content}}</p>
			<div slot="footer" class="dialog-footer">
				<el-button @click="nav_status.resource_watch_dialog = false">确 定</el-button>
			</div>
		</el-dialog>
	</el-row>

</template>

<script>
	export default {
		watch: {
			nbinput_value(val) {
				// 根据关键词过滤
				this.$refs.treenb.filter(val);
			},
			yzinput_value(val) {
				// 根据关键词过滤
				this.$refs.treeyz.filter(val);
			},
			classinput_value(val) {
				// 根据关键词过滤
				this.$refs.treeclass.filter(val);
			},
		},
		name: 'App',
		data() {
			return {
        disable_show:false,//禁用显示与否
        enable_show:false,//启用显示与否
        release_show:false,//发布显示与否
        class_checkkey:'',
				classinput_value: '', //分类搜索框
				yzinput_value: '', //药知搜索框
				nbinput_value: '', //内部搜索框
				//编辑的弹框
				edit_dialog: {
					uploadlist: {
            type:'add',
						cart_number: '', //编号
						name: '', //包名
						content: '', //备注
						xznbvideo_list: [], //选择之后的内部视频li's't
						xzyzvideo_list: [], //选择之后的药知list
						xzclass_list: [], //选择之后的所属分类list
					},
					yzshow_list: [], //显示的list
					nbshow_list: [], //显示的list
					classshow_list: [], //显示的list
					class_show: false,
					nbvideo_show: false,
					yzvideo_show: false,
					defaultPropsclass: {
						children: 'children',
						label: 'name',
					},
					defaultPropsyz: {
						children: 'children',
						label: 'name',
					},
					defaultPropsnb: {
						children: 'children',
						label: 'name',
					},
					nbvideo_list: [],
					yzvideo_list: [],
					class_list: [],
				},
				nav_status: {
					resource_edit_dialog: false,
					resource_watch_dialog: false,
					title: ''
				},
				resource_list: {
					current_page: 1, // 当前页码
					total: 0, // 总条数
					per_page: 10,
				},
				type_list: {},
				resource_edit: {},
				resource_watch: {
					'video': {
						'public': {}
					},
				},
				search: ''
			}
		},
		components: {

		},
		mounted: function() {
			this.get_train_resource()
			this.get_train_video()
			this.get_type()
		},
		methods: {
      indexAdd(index) {
            return index + 1
          },
      search_click(){
        this.get_train_resource()
      },
      //操作事件
      operation_click(num,type){
        let _this=this
        if(type=="disable_show" || type=="enable_show"){
          var data={
            num:num,
            type:'del'
          }
        }else{
          var data={
            num:num,
            type:'push'
          }
        }
        _this.axios.post('/v2/c_train/train_resource_up',{data:data}).then(function(res) {
        	if (res.status == '200') {
        		if (res.data.code == '1') {
              _this.$message.success(res.data.msg)
        			_this.get_train_resource()
        		} else {
        			_this.$message.error(res.data.msg)
        		}
        	} else {
        		_this.$message.error('服务器内部错误')
        	}
        }).catch(function(error) {
        	_this.$message.error('服务器内部错误')
        });
      },
      handleClick(data, checked, node){
             if (checked) {
                 let arr = [data.num];
                 this.$refs.treeclass.setCheckedKeys(arr);
               }
             },
			get_type() {
				let _this = this
				_this.axios.get('/v2/c_train/get_train_resource_type').then(function(res) {
					if (res.status == '200') {
						if (res.data.code == '1') {
							_this.edit_dialog.class_list = res.data.data
						} else {
							_this.$message.error(res.data.msg)
						}
					} else {
						_this.$message.error('服务器内部错误')
					}
				}).catch(function(error) {
					_this.$message.error('服务器内部错误')
				});
			},
			// get_train_video() {
			// 	let _this = this
			// 	_this.axios.get("/v2/c_train/get_train_video").then(function(res) {
			// 		if (res.status == "200") {
			// 			if (res.data.code == "1") {
			// 				_this.edit_dialog.yzvideo_list = res.data.data.public
			// 				_this.edit_dialog.nbvideo_list = res.data.data.local
			// 			} else {
			// 				_this.$message.error(res.data.msg);
			// 			}
			// 		} else {
			// 			_this.$message.error("服务器内部错误");
			// 		}
			// 	});
			// },

      get_train_video() {
      				let _this = this
              let show=false
      				_this.axios.get("/v2/c_train/get_train_video").then(function(res) {
      					if (res.status == "200") {
      						if (res.data.code == "1") {
      							_this.edit_dialog.yzvideo_list = res.data.data.public
      							_this.edit_dialog.nbvideo_list = res.data.data.local
                     show=true
                    let list=_this.edit_dialog.yzvideo_list
                    if(show){
                      for(let i=0;i<list.length;i++){
                        if(list[i].hasOwnProperty('children')){
                          for(let j=0;j<list[i].children.length;j++){
                            if(list[i].children[j].hasOwnProperty('children')){
                              for(let q=0;q<list[i].children[j].children.length;q++){
                                if(list[i].children[j].children[q].hasOwnProperty('children')){
                                  for(let w=0;w<list[i].children[j].children[q].children.length;w++){
                                    let aa=list[i].children[j].children[q].children[w].subject_num.split('_')
                                    let bb=aa[0]*1+aa[2]*1
                                        list[i].children[j].children[q].name =  list[i].children[j].children[q].name+'（'+bb+'题)'
                                        break
                                  }
                                }else{
                                  let aa=list[i].children[j].children[q].subject_num.split('_')
                                  let bb=aa[0]*1+aa[2]*1
                                  list[i].children[j].name =  list[i].children[j].name+'（'+bb+'题)'
                                  break
                                }
                              }
                            }else{
                              let aa=list[i].children[j].subject_num.split('_')
                              let bb=aa[0]*1+aa[2]*1
                              list[i].name =list[i].name+'（'+bb+'题)'
                              break
                            }
                          }
                        }
                      }
                      _this.edit_dialog.yzvideo_list=list
                    }

      						} else {
      							_this.$message.error(res.data.msg);
      						}
      					} else {
      						_this.$message.error("服务器内部错误");
      					}
      				});
      			},
			resource_save() {
        let _this=this
        _this.axios.post("/v2/c_train/train_resource_up",{data:_this.edit_dialog.uploadlist}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.$message.success(res.data.msg)
              _this.nav_status.resource_edit_dialog = false
              _this.get_train_resource()
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });

			},
			remove(type) {
				if (type == 'nb') {
					this.edit_dialog.nbvideo_show = false;
					this.edit_dialog.uploadlist.xznbvideo_list = this.edit_dialog.nbshow_list;
				} else if (type == 'yz') {
					this.edit_dialog.yzvideo_show = false;
					this.edit_dialog.uploadlist.xzyzvideo_list = this.edit_dialog.yzshow_list;
				} else if (type == 'class') {
					this.edit_dialog.class_show = false;
					this.edit_dialog.uploadlist.xzclass_list = this.edit_dialog.classshow_list;
				}
			},
			edit_click(type) {
				this.classinput_value = '',
					this.nbinput_value = '',
					this.yzinput_value = '';
				if (type == 'nb') {
					this.edit_dialog.nbvideo_show = true;
					let nblist = [];
					for (let i = 0; i < this.edit_dialog.uploadlist.xznbvideo_list.length; i++) {
						nblist.push(this.edit_dialog.uploadlist.xznbvideo_list[i].num);
					}
					this.edit_dialog.yzshow_list = this.edit_dialog.uploadlist.xznbvideo_list;
					this.$nextTick(function() {
						//Dom更新完毕
						this.$refs.treenb.setCheckedKeys(nblist);
					});
				} else if (type == 'yz') {
					this.edit_dialog.yzvideo_show = true;
					let yzlist = [];
					for (let i = 0; i < this.edit_dialog.uploadlist.xzyzvideo_list.length; i++) {
						yzlist.push(this.edit_dialog.uploadlist.xzyzvideo_list[i].num);
					}
					this.edit_dialog.yzshow_list = this.edit_dialog.uploadlist.xzyzvideo_list;
					this.$nextTick(function() {
						//Dom更新完毕
						this.$refs.treeyz.setCheckedKeys(yzlist);
					});
				} else if (type == 'class') {
					this.edit_dialog.class_show = true;
					let classlist = [];
					for (let i = 0; i < this.edit_dialog.uploadlist.xzclass_list.length; i++) {
						classlist.push(this.edit_dialog.uploadlist.xzclass_list[i].num);
					}
					this.edit_dialog.classshow_list = this.edit_dialog.uploadlist.xzclass_list;
					this.$nextTick(function() {
						//Dom更新完毕
						this.$refs.treeclass.setCheckedKeys(classlist);
					});
				}
			},
			//药知视频的清空
			yzremove() {
				let _this = this;
				_this.edit_dialog.yzshow_list = [];
				_this.$nextTick(function() {
					//Dom更新完毕
					this.$refs.treeyz.setCheckedKeys([]);
				});
			},
			//药知视频的确定
			yzvideo_click() {
				let _this = this;
				let a = this.$refs.treeyz.getCheckedNodes();
				let j = 0;
				_this.edit_dialog.yzshow_list = [];
				if (a.length == 0) {
					_this.edit_dialog.yzshow_list = [];
					return
				}
				for (let i = 0; i < a.length; i++) {
					if (a[i].hasOwnProperty('status')) {
						this.$set(_this.edit_dialog.yzshow_list, j, a[i])
						j++;
					}
				}
			},
			//内部视频的清空
			nbremove() {
				let _this = this;
				_this.edit_dialog.nbshow_list = [];
				_this.$nextTick(function() {
					//Dom更新完毕
					this.$refs.treenb.setCheckedKeys([]);
				});
			},
			//内部视频的确定
			nbvideo_click() {
				let _this = this;
				let a = this.$refs.treenb.getCheckedNodes();
				let j = 0;
				_this.edit_dialog.nbshow_list = [];
				if (a.length == 0) {
					_this.edit_dialog.nbshow_list = [];
					return
				}
				for (let i = 0; i < a.length; i++) {
					if (a[i].hasOwnProperty('status')) {
						this.$set(_this.edit_dialog.nbshow_list, j, a[i])
						j++;
					}
				}
			},
			classvideo_click() {
				let _this = this;
				let a = this.$refs.treeclass.getCheckedNodes();
				let j = 0;
				_this.edit_dialog.classshow_list = [];
				if (a.length == 0) {
					_this.edit_dialog.classshow_list = [];
					return
				}
				for (let i = 0; i < a.length; i++) {
					this.$set(_this.edit_dialog.classshow_list, j, a[i])
					j++;
				}
			},
			classremove() {
				let _this = this;
				_this.edit_dialog.classshow_list = [];
				_this.$nextTick(function() {
					//Dom更新完毕
					this.$refs.treeclass.setCheckedKeys([]);
				});
			},
			get_train_resource() {
				let _this = this;
				_this.axios.get("/v2/c_train/get_train_resource", {
					params: {
						'page': _this.resource_list.current_page,
						'limit': _this.resource_list.per_page,
						'type': '0','keyword':_this.search
					}
				}).then(function(res) {
					if (res.status == "200") {
						if (res.data.code == "1") {
							_this.resource_list = res.data.data
              // disable_show:false,//禁用显示与否
              // enable_show:false,//启用显示与否
              // release_show:false,//发布显示与否
              let list=res.data.data.data
              for( let i=0;i<list.length;i++){
                _this.release_show=false
                _this.disable_show=false
                _this.enable_show=false
                if(list[i].status=='0'){
                  _this.enable_show=true
                }else{
                  if(list[i].push=='0'){
                    _this.release_show=true
                  }
                  _this.disable_show=true
                }
                _this.resource_list.data[i]['release_show']=_this.release_show
                _this.resource_list.data[i]['enable_show']=_this.enable_show
                _this.resource_list.data[i]['disable_show']=_this.disable_show
              }
							_this.resource_list.per_page = parseInt(_this.resource_list.per_page)
						} else {
							_this.$message.error(res.msg);
						}
					} else {
						_this.$message.error("服务器内部错误");
					}
				});
			},

			handleSizeChange(val) {
				this.resource_list.current_page = 1;
				this.resource_list.per_page = val
				this.get_train_resource()
			},

			handleCurrentChange(val) {
				let _this = this
				_this.resource_list.current_page = val
				_this.get_train_resource()
			},
			//tree搜索框时间
			filterNodenb(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},
			filterNodeyz(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},
			filterNodeclass(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},
			resource_watch_click(num) {
				let _this = this;
				_this.get_train_resource_info(num, 'watch')

			},
			resource_edit_click(num,type) {
				let _this = this;
        _this.edit_dialog.uploadlist.type=type
				if(type!='add'){
					_this.get_train_resource_info(num, 'edit')
          _this.nav_status.title="编辑"
          _this.edit_dialog.uploadlist.num=num
				}else{
          _this.nav_status.title="新增"
					_this.show_resource_edit_dialog({"num":null,"cart_number": null,"t_id": "0","name": '', 't_num':'','t_name':'',"video": {"local": [],"public": []},"content": null
})
				}

			},

			//弹框确定按钮时间
			class_Submit() {
				let _this = this;
				_this.setup.class_tk = false;
			},

			get_train_resource_info(num, type) {
				let _this = this
				_this.axios.get("/v2/c_train/get_train_resource_info", {
					params: {
						'num': num
					}
				}).then(function(res) {
					if (res.status == "200") {
						if (res.data.code == "1") {
							if (type == 'watch') {
								_this.resource_watch = res.data.data
								_this.nav_status.resource_watch_dialog = true
							} else if (type == 'edit') {
								_this.show_resource_edit_dialog(res.data.data)
							}
						} else {
							_this.$message.error(res.data.msg);
						}
					} else {
						_this.$message.error("服务器内部错误");
					}
				});
			},

			 show_resource_edit_dialog(info) {
			    let _this = this
			        let showclass=[]
			        if(info.t_num=="" && info.t_name==""){
			        }else{
			          showclass=[ {'num':info.t_num,'name':info.t_name}]
			        }
			    _this.edit_dialog.uploadlist.name = info.name;
			    _this.edit_dialog.uploadlist.cart_number = info.cart_number;
			    _this.edit_dialog.uploadlist.xzyzvideo_list = _this.edit_dialog.yzshow_list = info.video.public;
			    _this.edit_dialog.uploadlist.xznbvideo_list = _this.edit_dialog.nbshow_list = info.video.local;
			        _this.edit_dialog.uploadlist.xzclass_list = _this.edit_dialog.classshow_list =showclass;
			        _this.edit_dialog.uploadlist.content = info.content;
			    _this.nav_status.resource_edit_dialog = true
			   },

			//新增编辑分类弹框事件
			resource_up(type, num) {
				let _this = this
				_this.get_train_resource_info(num, 'edit')
			},
		}
	}
</script>

<style scoped>
	.firstdiv{
	  margin-top: 10px;

	  width: 95%;
	  height: 70px;
	  display: flex;
	  align-items: center;
	  padding-left: 20px;
	}
	.content{
	  width: 96%;
	  margin-top: 10px;
	}
	.content_right_first{
	    margin: 10px;
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	  }
	  .content_right{

	    padding: 20px;
	  }
	  .fenye{
	    text-align: center;
	    margin-top: 20px;
	  }
	  .ercitankuang_left{
	     border:1px solid 	#9D9D9D;
	     height:400px;
	     flex: 1;
	     overflow:scroll;
	     position:relative;
	    }
	   .ercitankuang_right{
	     border:1px solid 	#9D9D9D;
	     height:400px;
	     flex: 1;
	     overflow:scroll;
	   }
	    .ercitankuang_content{
	         flex: 0.1;
	       text-align:center;
	       height: 400px;
	     }
       .block{
         text-align: center;
         margin-top: 10px;
         margin-bottom: 10px;
       }
       >>>.el-tree-node{
                white-space: normal;
                margin-top: 0.625rem;
              }
</style>



// WEBPACK FOOTER //
// src/view/company/train/ResourcesPack/Standard.vue